





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VerticalStep from '@/components/ui/form/VerticalStep.vue'
import { TriggeredReferral } from '@/api/model/triggered-referral'

@Component({
    components: { VerticalStep },
})
export default class CreateAutoLeadVerticalStep3 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: TriggeredReferral
}
